import React, { useEffect, useState } from 'react';

export default function IntegerInput({
  field,
  inputKey,
  saveOptions,
  errors,
  isEditable = true,
  defaultValue = null,
}) {
  const [inputValue, setValue] = useState('');
  useEffect(() => {
    if (defaultValue) setValue(defaultValue);
  }, [defaultValue]);

  const handleChange = (e) => {
    saveOptions(inputKey, e.target.value);
    setValue(e.target.value);
  };

  return (
    <div>
      <input
        type='number'
        placeholder={field?.placeholder}
        className={`tw-appearance-none tw-px-5 tw-py-2 tw-h-16 tw-rounded-lg tw-outline-0  focus:tw-border-none focus:tw-ring-[1.5px] tw-w-full
    ${
      errors?.old_email?.message
        ? 'focus:tw-ring-[#BF2938] focus:tw-border-RED'
        : 'focus:tw-ring-green-500 focus:tw-border-green-500'
    }  tw-border tw-border-solid tw-border-[#cfcfcf]`}
        autocomplete='off'
        onChange={handleChange}
        value={inputValue}
        readOnly={!isEditable}
      />
    </div>
  );
}
